$(document).ready(function () {
    var already_submitted = false;
    $("form#newsletter-form").validate({
        rules: {
            email_newsletter: {
                required: true,
                minlength: 2,
                validate_email: true
            },
            terms_newsletter: {
                required: true
            }
        },
        messages: {
            terms_newsletter: {
                required: "Obligatorio"
            },
            email_newsletter: {
                required: "Ingrese su email",
                minlength: "Debes ingresar un email válido",
                email_newsletter: "Debes ingresar un email válido",
                email_newsletter: "Debes ingresar un email válido"
            }
        },
        submitHandler : function(form) {
            if (!window.already_submitted) {
                window.already_submitted = true;
                $.ajax({
                    url: '/newsletter/store',
                    type: "POST",
                    data: $("form#newsletter-form").serialize(),
                    success: function(response) {
                        console.log(response);
                        if(response == 'Existe'){
                            $('#newsletter-form p').text("El email ingresado ya existe!");
                        }else if (response == 'ok'){
                            $('#newsletter-form p').text("El email fue ingresado con éxito!");
                        }
                        $("form#newsletter-form #email_newsletter").val("");
                        window.already_submitted = false;
                    },
                    error: function (error) {
                        console.log(error);
                    }
                });
            }
        }
    });
    $.validator.addMethod("validate_email",function(value, element) {
       if(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test( value )) {
           return true;
        }
        else {
          return false;
        }
    },"{{ lang('Debes ingresar un email válido') }}");

    $("form#newsletter-form #btn-submit").click(function (e) {
        e.preventDefault();
        $("form#newsletter-form").submit();
    });
});
